import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

export const ShowMessageBox = (props) => {
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }  
        props.setOpen(false);
      };
      
      function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
      }      
  
  
    return (
        <div>
            <Snackbar open={props.open} autoHideDuration={6000} onClose={handleCloseSnackBar}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                        }}>
                <Alert onClose={handleCloseSnackBar} severity={props.severity}>
                    {props.msg}
                </Alert>
            </Snackbar>
        </div>
    );
}

